import saveAs from 'file-saver';

import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import '../types';

const shift = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getShiftDispatcherReportExcel: builder.query<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Shift/${data.id}/dispatcherReport`,
        responseHandler: async (response) => {
          saveAs(new Blob([await response.blob()], { type: 'application/octet-stream' }), 'report.xlsx');
        },
      }),
    }),
  }),
});

export const { useGetShiftDispatcherReportExcelQuery, useLazyGetShiftDispatcherReportExcelQuery } = shift;
